<template>
<div class="live_bill_page">
  <!-- 流量管理 直播数流水查询 -->
  <div class="page-title">直播数流水查询</div>
  <pageTab :paramsLabel="'type'" :isParams="true" :nowTab="nowTab" :tabs="tab"></pageTab>
  <page-search :layout="searchLayout"  @search="search" @exportTable="exportTable"></page-search>
  <pageTable
    :loading="tableLoading"
    :col="col"
    :data="tableData"
    :total="total"
    :pageIndex="page"
    :pageSize="pageSize"
    @compFn="customCompFunc"
    @pageChange="pageChange"
    @pageSizeChange="pageSizeChange"
    ></pageTable>
</div>
</template>
<script>
import { zhiboshuLiushui } from '@/api/flow'
import pageTab from '@/components/pageCom/pageTab.vue'
import pageSearch from '@/components/pageCom/pageSearch.vue'
import pageTable from '@/components/pageCom/pageTable.vue'
import pageTableMixin from '@/components/pageCom/pageTableMixin.js'
import { formatTitle } from '@/utils/common'
import { downFile } from '@/utils/file'
import Vue from 'vue'
import billCheckOpe from '@/components/pageCom/billCheckOpe'
Vue.component('bill-check-ope', billCheckOpe)
export default {
  name: 'memberBill',
  components: {
    pageTab, pageSearch, pageTable
  },
  mixins: [pageTableMixin],
  data() {
    return {
      tab: [
        { linkName: 'all', text: '全部' },
        { linkName: 'zhifubao', text: '支付宝' },
        { linkName: 'outline', text: '线下转账' }
      ],
      searchLayout: ['name', 'date', 'export', 't_agent_info_agent_name'],
      col: [],
      allCol: [ // 全部
        { field: 'order_no', title: '订单编号', width: 240, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 'create_time', title: '下单日期', width: 140, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 'pay_status', title: '状态', width: 80, isResize: true, titleAlign: 'left', columnAlign: 'left',
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field] * 1 === 1) {
              return `<span>已付款</span>`
            } else if (rowData[field] * 1 === 0) {
              return `<span style="color: #DFA338">待付款</span>`
            } else if (rowData[field] * 1 === 3) {
              return `<span style="color: #DFA338">待审核</span>`
            }
          }
        },
        { field: 'pay_type', title: '支付方式', width: 110, isResize: true, titleAlign: 'left', columnAlign: 'left',
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field] * 1 === 1) {
              return `<span>支付宝</span>`
            } else if (rowData[field] * 1 === 2) {
              return `<span>线下转账</span>`
            }
          } },
        { field: 'cust_no', title: '企业编码', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 't_agent_info_agent_name', title: '渠道', width: 160, isResize: true, titleAlign: 'left', columnAlign: 'left', formatter(rowData, rowIndex, pagingIndex, field) {
          return formatTitle(rowData[field])
        } },
        { field: 'cust_name', title: '下单用户', width: 220, isResize: true, titleAlign: 'left', columnAlign: 'left', formatter(rowData, rowIndex, pagingIndex, field) {
          return formatTitle(rowData[field])
        } },
        { field: 'fuwuneirong', title: '服务内容', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left',
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field] * 1 === 0) {
              return `<span>会议场次</span>`
            } else if (rowData[field] * 1 === 2) {
              return `<span>服务内容</span>`
            }
          }
        },
        { field: 'buy_amount', title: '数量', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 'pay_price', title: '订单金额', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left' }
      ],
      zhifubaoCol: [ // 支付宝
        { field: 'order_no', title: '订单编号', width: 240, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 'create_time', title: '下单日期', width: 140, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 'pay_status', title: '状态', width: 80, isResize: true, titleAlign: 'left', columnAlign: 'left',
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field] * 1 === 1) {
              return `<span>已付款</span>`
            } else if (rowData[field] * 1 === 0) {
              return `<span style="color: #DFA338">待付款</span>`
            } else if (rowData[field] * 1 === 3) {
              return `<span style="color: #DFA338">待审核</span>`
            }
          }
        },
        { field: 'pay_type', title: '支付方式', width: 110, isResize: true, titleAlign: 'left', columnAlign: 'left',
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field] * 1 === 1) {
              return `<span>支付宝</span>`
            }
          }
        },
        { field: 'cust_no', title: '企业编码', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 't_agent_info_agent_name', title: '渠道', width: 160, isResize: true, titleAlign: 'left', columnAlign: 'left', formatter(rowData, rowIndex, pagingIndex, field) {
          return formatTitle(rowData[field])
        } },
        { field: 'cust_name', title: '下单用户', width: 220, isResize: true, titleAlign: 'left', columnAlign: 'left', formatter(rowData, rowIndex, pagingIndex, field) {
          return formatTitle(rowData[field])
        } },
        { field: 'fuwuneirong', title: '服务内容', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left',
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field] * 1 === 0) {
              return `<span>会议场次</span>`
            } else if (rowData[field] * 1 === 2) {
              return `<span>服务内容</span>`
            }
          }
        },
        { field: 'buy_amount', title: '数量', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 'pay_price', title: '订单金额', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left' }
      ],
      outlineCol: [ // 线下转账
        { field: '', title: '操作', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left', componentName: 'bill-check-ope' },
        { field: 'order_no', title: '订单编号', width: 240, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 'create_time', title: '下单日期', width: 140, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 'pay_status', title: '状态', width: 80, isResize: true, titleAlign: 'left', columnAlign: 'left',
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field] * 1 === 1) {
              return `<span>已付款</span>`
            } else if (rowData[field] * 1 === 0) {
              return `<span style="color: #DFA338">待付款</span>`
            } else if (rowData[field] * 1 === 3) {
              return `<span style="color: #DFA338">待审核</span>`
            }
          }
        },
        { field: 'pay_type', title: '支付方式', width: 110, isResize: true, titleAlign: 'left', columnAlign: 'left',
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field] * 1 === 2) {
              return `<span>线下转账</span>`
            }
          }
        },
        { field: 'cust_no', title: '企业编码', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 't_agent_info_agent_name', title: '渠道', width: 160, isResize: true, titleAlign: 'left', columnAlign: 'left', formatter(rowData, rowIndex, pagingIndex, field) {
          return formatTitle(rowData[field])
        } },
        { field: 'cust_name', title: '下单用户', width: 220, isResize: true, titleAlign: 'left', columnAlign: 'left', formatter(rowData, rowIndex, pagingIndex, field) {
          return formatTitle(rowData[field])
        } },
        // { field: 'fuwuneirong', title: '服务内容', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 'buy_amount', title: '数量', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 'pay_price', title: '订单金额', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left' }
      ],
      tmpParams: {} // 搜索成功的临时参数
    }
  },
  computed: {
    nowTab() {
      return this.$route.params.type
    }
  },
  methods: {
    initPage() {
      if (this.$route.params.type === 'all') {
        this.col = this.allCol
      } else if (this.$route.params.type === 'zhifubao') {
        this.col = this.zhifubaoCol
      } else if (this.$route.params.type === 'outline') {
        this.col = this.outlineCol
      }
    },
    search(params) { // 搜索组件传参
      this.page = 1
      this.pageSize = 30
      this.realGetData({
        'per_page': 30,
        page: 1,
        cust_name: params.name,
        create_time_start: params.date[0],
        create_time_end: params.date[1],
        t_agent_info_agent_name: params.t_agent_info_agent_name
      })
    },
    exportTable() { // 导出数据
      const downNum = { 'all': 13, 'zhifubao': '14', 'outline': '15' }[this.$route.params.type]
      const query = { ...this.tmpParams, table_type: downNum }
      const url = process.env.VUE_APP_BASE_API + '/business/export_excel'
      downFile(url, query)
    },
    getData(init) { // init代表 mounted watch查询
      if (init) { // 代表的是 mounted watch
        this.realGetData({
          cust_name: '', create_time_start: '', create_time_end: '', t_agent_info_agent_name: '',
          'per_page': 30, page: 1
        })
      } else { // 分页获取数据
        this.realGetData(Object.assign({}, this.tmpParams, { 'per_page': this.pageSize, page: this.page }))
      }
    },
    realGetData(params) { // 真正的获取数据 需要参数
      this.tableLoading = true
      if (this.$route.params.type === 'all') {
        zhiboshuLiushui('all', params).then(res => {
          this.handleData(res, params)
        })
      } else if (this.$route.params.type === 'zhifubao') {
        zhiboshuLiushui('zhifubao', params).then(res => {
          this.handleData(res, params)
        })
      } else if (this.$route.params.type === 'outline') {
        zhiboshuLiushui('outline', params).then(res => {
          this.handleData(res, params)
        })
      }
    },
    customCompFunc({ type, rowData }) {
      this.$router.push({
        name: type === 'check' ? 'flowcheck' : 'flowscan',
        params: {
          type: 'live',
          id: rowData['order_no']
        }
      })
    },
    handleData(res, params) { // 统一处理数据
      this.tableLoading = false
      if (res.code === 0) {
        this.tableData = res.result.data
        this.total = res.result.total
        this.tmpParams = params
      } else {
        this.tableData = []
        this.total = 0
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>

